module.exports = __webpack_public_path__ + "static/media/img8.78228d73.jpg";